const highContrastColors = [
    "#1F77B4",
    "#FF7F0E",
    "#D62728",
    "#9467BD",
    "#8C564B",
    "#E377C2",
    "#7F7F7F",
    "#BCBD22",
    "#17BECF",
    "#2CA02C",
];

const backgroundColorViewer = "#e4ede9";

const splitHexAlpha = (color: string) => {
  const hex = color.slice(0, 7);   // #RRGGBB
  const alphaHex = color.slice(7, 9); // AA

  const alpha = alphaHex
    ? Math.round(parseInt(alphaHex, 16) / 255 * 100) / 100
    : 1;

  return { hex, alpha };
}

export { highContrastColors, backgroundColorViewer, splitHexAlpha } ;